import { render, staticRenderFns } from "./applicationContentDetail.vue?vue&type=template&id=bf516a26&scoped=true"
import script from "./applicationContentDetail.vue?vue&type=script&lang=js"
export * from "./applicationContentDetail.vue?vue&type=script&lang=js"
import style0 from "./applicationContentDetail.vue?vue&type=style&index=0&id=bf516a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf516a26",
  null
  
)

export default component.exports